import { Widget, DomUtil } from '@cesium-extends/common';
import { ScreenSpaceEventHandler, Cartesian2, ScreenSpaceEventType } from 'cesium';

var e=[],t=[];function n(n,r){if(n&&"undefined"!=typeof document){var a,s=!0===r.prepend?"prepend":"append",d=!0===r.singleTag,i="string"==typeof r.container?document.querySelector(r.container):document.getElementsByTagName("head")[0];if(d){var u=e.indexOf(i);-1===u&&(u=e.push(i)-1,t[u]={}),a=t[u]&&t[u][s]?t[u][s]:t[u][s]=c();}else a=c();65279===n.charCodeAt(0)&&(n=n.substring(1)),a.styleSheet?a.styleSheet.cssText+=n:a.appendChild(document.createTextNode(n));}function c(){var e=document.createElement("style");if(e.setAttribute("type","text/css"),r.attributes)for(var t=Object.keys(r.attributes),n=0;n<t.length;n++)e.setAttribute(t[n],r.attributes[t[n]]);var a="prepend"===s?"afterbegin":"beforeend";return i.insertAdjacentElement(a,e),e}}

var css = ".cesium-tool-tip{background:rgba(0,0,0,.6);border-radius:4px;color:#fff;left:0;line-height:30px;min-height:30px;min-width:100px;padding:0 10px;pointer-events:none;position:absolute;top:0;visibility:hidden;z-index:-1}.cesium-tool-tip:before{border-bottom:10px solid transparent;border-right:10px solid rgba(0,0,0,.6);border-top:10px solid transparent;content:\"\";display:block;left:-10px;pointer-events:none;position:absolute;top:calc(50% - 10px)}";
n(css,{});

class Tooltip extends Widget {
  /**
   * Cesium tooptip
   * @param viewer
   */
  constructor(viewer, options = {}) {
    super(viewer, DomUtil.create("div", "cesium-tool-tip"));
    this._offset = options.offset ?? [0, 0];
    this._content = options.content ?? "";
  }
  set content(val) {
    if (!this.enabled)
      this.enabled = true;
    this._content = val;
    this.setContent(val);
    this.show();
  }
  get content() {
    return this._content;
  }
  /**
   *
   * @param {Cartesian2} windowCoord
   */
  _updateWindowCoord(windowCoord) {
    const x = windowCoord.x + 20 + this._offset[0];
    const y = windowCoord.y - this._wrapper.offsetHeight / 2 + this._offset[1];
    this._wrapper.style.cssText = `
    visibility:visible;
    z-index:1;
    transform:translate3d(${Math.round(x)}px,${Math.round(y)}px, 0);
    `;
  }
  /**
   * @param windowPosition
   * @param content
   * @returns {Tooltip}
   */
  showAt(windowPosition, content) {
    if (!this._enabled) {
      return this;
    }
    if (windowPosition)
      this._updateWindowCoord(windowPosition);
    this.setContent(content);
    return this;
  }
}

class MouseTooltip extends Tooltip {
  constructor(viewer, options = {}) {
    super(viewer, options);
    this._destroyed = false;
    this._handler = new ScreenSpaceEventHandler(viewer.scene.canvas);
    this.enabled = true;
    this.showAt(new Cartesian2(0, 0), this.content);
  }
  get destroyed() {
    return this._destroyed;
  }
  /**
   * 显示tooltip
   */
  show() {
    if (this._destroyed)
      return;
    super.show();
    this._handler.setInputAction((movement) => {
      const { endPosition } = movement;
      if (endPosition) {
        const ray = this._viewer.camera.getPickRay(endPosition);
        if (!ray)
          return;
        const cartesian = this._viewer.scene.globe.pick(ray, this._viewer.scene);
        if (cartesian)
          this._updateWindowCoord(endPosition);
      }
    }, ScreenSpaceEventType.MOUSE_MOVE);
  }
  /**
   * 隐藏tooltip
   */
  hide() {
    if (this._destroyed)
      return;
    super.hide();
    this._handler.removeInputAction(ScreenSpaceEventType.MOUSE_MOVE);
  }
  destroy() {
    this.enabled = false;
    if (!this._handler.isDestroyed()) {
      this._handler.destroy();
    }
    this._destroyed = true;
  }
}

export { MouseTooltip, Tooltip };
